<template>
  <div class="modal fade" :id="name + '-modal'" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content" :class="cclass">
        <slot>
          <!-- HOW TO CALL -->
          <!--  <a data-toggle="modal" data-target="#comentario-modal">notifications_active</a> -->
          <!-- <modal name="comentario" :cclass="any class you want or need for the modal content"></modal> -->
          <div class="modal-header">
            div.modal-header
          </div>
          <div class="modal-body">
            div.modal-body
          </div>
          <div class="modal-footer">
            div.modal-footer
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['name', 'cclass'],
    data() {
      return {
        modalEventTime: null,
      }
    },
    methods: {
      timeoutM(mbd) {
        if(mbd) {
          mbd.addEventListener('click', () => {
            if(mbd.parentNode !== null) {
              mbd.parentNode.removeChild(mbd)
            }

            clearInterval(this.modalEventTime)
          })
        }
      }
    },
    mounted() {
      let mbd = document.querySelector('.modal-backdrop')
      let glob = this
      if (mbd !== null) {
        this.timeoutM(mbd)
      } else {
        this.modalEventTime = setInterval(function () {
           let mbd = document.querySelector('.modal-backdrop')
          if (mbd !== null) {
            glob.timeoutM(mbd)
          }
        }, 500)
      }
    }
  }

</script>

<style lang="scss" scoped>
  @import '~varmix';
  .modal {
    background-color: rgba(0, 0, 0, 0.8)
  }

  .transparent {
    background-color: transparent;
    box-shadow: none;
    border: none;
  }

</style>



// WEBPACK FOOTER //
// Modal.vue?05ecf3bd